import { useLocation, useNavigate } from "react-router-dom";

export const useQueryParameter = (key) => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get(key);
};

export const useReplaceQueryParameter = () => {
    const location = useLocation();
    const navigate = useNavigate();

    return ({ key, value }) => {
        const searchParams = new URLSearchParams(location.search);

        if (value === undefined || value.trim() === "") {
            searchParams.delete(key);
        } else {
            searchParams.set(key, value);
        }

        navigate(`${location.pathname}?${searchParams.toString()}`);
    };
};